import angular from 'angular';

import rootComponent from './components/root/root.component';
import titleBar from './components/titleBar/titleBar.component';
import menuBar from './components/menuBar/menuBar.component';

import httpProviderConfig from './configs/httpProvider.config';
import locationProviderConfig from './configs/locationProvider.config';

import MENU_ITEMS from './constants/menu.constants';

import APIVersionInterceptor from './services/apiVersionInterceptor';
import AppUpdates from './services/appUpdates';

import xhrFactoryDecorator from './decorators/xhrFactory.decorator';
import exceptionHandlerDecorator from './decorators/exceptionHandler.decorator';

import routesValidation from './eventSubscribers/routesValidation';

/**
 * @ngdoc overview
 * @name rootModule
 * @description
 * This is the application main module, it implements the `<root>` component, which shows the
 * `ng-view` for the Angular router, making it the main container for all the "sub modules".
 */
const rootModule = angular.module('rootModule', [])
.config(httpProviderConfig)
.config(locationProviderConfig)
.service('appUpdates', AppUpdates)
.service('apiVersionInterceptor', APIVersionInterceptor)
.component('root', rootComponent)
.component('titleBar', titleBar)
.component('menuBar', menuBar)
.constant('MENU_ITEMS', MENU_ITEMS)
.decorator('$exceptionHandler', exceptionHandlerDecorator)
.decorator('$xhrFactory', xhrFactoryDecorator)
.run(routesValidation);

export default rootModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/index.js